import type { Shift } from "../api/types";
import { formatTime24 } from "../utils/time24";

interface ShiftChipProps {
  shift: Shift;
  onClick?: () => void;
}

const STATUS_LABEL: Record<Shift["status"], string> = {
  SCHEDULED: "Scheduled",
  IN_PROGRESS: "In progress",
  COMPLETED: "Completed",
  MISSED: "Missed",
  CANCELED: "Canceled",
};

export function ShiftChip({ shift, onClick }: ShiftChipProps) {
  const planned = `${formatTime24(shift.plannedStart)}–${formatTime24(shift.plannedEnd)}`;
  const label = `${shift.user.fullName} · ${planned} · ${STATUS_LABEL[shift.status]}`;
  return (
    <button
      type="button"
      className={`shift-chip status-${shift.status.toLowerCase()}`}
      onClick={onClick}
      title={label}
      aria-label={label}
    >
      <span className="shift-chip-head">
        <span className="shift-chip-dot" aria-hidden="true" />
        <span className="shift-chip-name">{shift.user.fullName}</span>
      </span>
      <span className="shift-chip-time">{planned}</span>
    </button>
  );
}
